import React, { useState } from 'react';
import "./estilos.css";
import InstagramIcon from '@mui/icons-material/Instagram';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const whatsappNumber = '2281460124';

function FormularioContacto() {
    const [mensaje, setMensaje] = useState("");
    const [error, setError] = useState("");

    const sendWhatsapp = (e) => {
        e.preventDefault();

        if (!mensaje.trim()) {
            setError("Escribi un mensaje para enviarlo por WhatsApp.");
            return;
        }

        setError("");
        const whatsappMessage = encodeURIComponent(`Hola Marcos, ${mensaje.trim()}`);
        window.open(`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className='contGralForm'>
            <div className='formIntro'>
                <span>Contacto</span>
                <h3 className='tituloForm'>Hablemos de tu proximo proyecto</h3>
                <p>Escribime por una propuesta, una consulta tecnica o una oportunidad laboral.</p>

                <div className='contactSocials' aria-label='Redes de contacto'>
                    <a href='https://www.instagram.com/fmarcos_casla/' target='_blank' rel='noreferrer' aria-label='Instagram'>
                        <InstagramIcon /> Instagram
                    </a>
                    <a href='https://github.com/fmarcos38' target='_blank' rel='noreferrer' aria-label='GitHub'>
                        <GitHubIcon /> GitHub
                    </a>
                    <a href='https://www.linkedin.com/in/marcos-forastiere-9b238328/' target='_blank' rel='noreferrer' aria-label='LinkedIn'>
                        <LinkedInIcon /> LinkedIn
                    </a>
                    <a href={`https://wa.me/${whatsappNumber}`} target='_blank' rel='noreferrer' aria-label='WhatsApp'>
                        <WhatsAppIcon /> WhatsApp
                    </a>
                </div>
            </div>

            <div className='divContForm'>
                <form onSubmit={sendWhatsapp} className='contForm'>
                    <div className='formField'>
                        <label htmlFor='mensaje'>Mensaje</label>
                        <textarea
                            id='mensaje'
                            rows='7'
                            value={mensaje}
                            onChange={(e) => setMensaje(e.target.value)}
                            placeholder='Contame brevemente que necesitas...'
                        />
                    </div>

                    {error && <p className='formError'>{error}</p>}
                    <button type='submit' className='btnEnviar'>
                        <WhatsAppIcon /> Enviar por WhatsApp
                    </button>
                </form>
            </div>
        </div>
    )
}

export default FormularioContacto
